
import poll from './PollReducers';

export default poll;
